import { CpuIcon, RefreshCwIcon, ThermometerIcon, WindIcon, WrenchIcon, CogIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'HVAC Fundamentals: Heat, Thermodynamics & Psychrometrics',
    summary: 'Temperature vs heat, heat transfer, sensible and latent heat, pressure and boiling point, enthalpy, airflow, moist air properties, the psychrometric chart, comfort and heating and cooling loads.',
    icon: ThermometerIcon,
  },
  {
    number: '2',
    title: 'The Refrigeration Cycle & Refrigerants',
    summary: 'The vapour-compression cycle step by step, pressure-temperature relationships, superheat and subcooling, the P-h diagram, refrigerant families, safety classes and responsible handling.',
    icon: RefreshCwIcon,
  },
  {
    number: '3',
    title: 'System Components: Compressors, Condensers, Evaporators & Metering Devices',
    summary: 'Compressor types, condensers and evaporators, TXV, EEV and fixed metering devices, accessories, piping and how every component affects system performance.',
    icon: CogIcon,
  },
  {
    number: '4',
    title: 'HVAC Systems & Air Distribution',
    summary: 'Splits, VRF, packaged rooftop units, chilled-water plants, air handling units, fans, ductwork, terminal units, ventilation and air and water balancing.',
    icon: WindIcon,
  },
  {
    number: '5',
    title: 'Controls, Electrical Circuits & Building Automation',
    summary: 'Control loops, sensors and actuators, wiring diagrams, contactors, relays and motors, VFDs, safety controls and building automation systems.',
    icon: CpuIcon,
  },
  {
    number: '6',
    title: 'Installation, Commissioning, Troubleshooting & Maintenance',
    summary: 'Installation best practices, pressure testing, evacuation and charging, start-up and commissioning, systematic diagnosis and preventive maintenance routines.',
    icon: WrenchIcon,
  },
];
